var React = require('react');

function LeftCaret (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#696969;}")),React.createElement("path",{"className":"a","d":"M5.357.159a.479.479,0,0,0-.714,0l-4.5,4.9a.587.587,0,0,0,0,.778.475.475,0,0,0,.713,0L5,1.327,9.139,5.839a.475.475,0,0,0,.714,0,.587.587,0,0,0,0-.778Z","transform":"translate(0 10) rotate(-90)","key":1})]);
}

LeftCaret.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10"};

module.exports = LeftCaret;

LeftCaret.default = LeftCaret;
